import { render, staticRenderFns } from "./index.vue?vue&type=template&id=01f5cafb&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f5cafb')) {
      api.createRecord('01f5cafb', component.options)
    } else {
      api.reload('01f5cafb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=01f5cafb&", function () {
      api.rerender('01f5cafb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/repair/index.vue"
export default component.exports